import { useLayoutEffect, useState } from "react";
import YouTube from "react-youtube";
import axios from "axios";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import config from "../config";

function Banner_data({ medium_cover_image, title, summary, likes, trailerKey: initialTrailerKey }) {
    const theme = useTheme();
    const memberId = window.sessionStorage.getItem("id");
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const containerStyle = isSmallScreen
        ? {
              height: "470px",
              display: "flex",
              marginLeft: "8.5%",
              flexDirection: "column",
          }
        : isMediumScreen
          ? {
                height: "350px",
                display: "flex",
                marginLeft: "8.5%",
                justifyContent: "space-between",
            }
          : {
                height: "350px",
                display: "flex",
                justifyContent: "center",
            };
    const imgStyle = isMediumScreen
        ? {
              display: "none",
          }
        : {
              backgroundImage: `url(${medium_cover_image})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              width: "230px",
              height: "345px",
              marginLeft: "10px",
          };
    const playerStyle = isSmallScreen
        ? { marginTop: "10px", width: "30%", height: "70%" }
        : {
              marginLeft: "50px",
          };

    const btnStyle = isMediumScreen
        ? {
              width: "25%",
              position: "center",
              backgroundPosition: "left",
          }
        : {
              diplay: "none",
          };
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 780,
        height: 400,
        bgcolor: "rgba(0,0,0,0.8)",
        border: "2px solid #000",
        boxShadow: 24,
        p: 2,
        display: "flex",
        zIndex: 9999,
    };

    const [trailerKey] = useState(initialTrailerKey || null);

    const [open, setOpen] = useState(false);
    const handleOpen = (e) => {
        e.stopPropagation();
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    const [ischecked, setIsChecked] = useState(false);

    useLayoutEffect(() => {
        axios
            .post(`${config.API_URL}/favmovie/chk`, {
                movie_title: title,
                member_id: window.sessionStorage.getItem("id"),
            })
            .then((res) => {
                if (res.data?.length) {
                    setIsChecked(true);
                } else {
                    setIsChecked(false);
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }, [title]);

    const handlelike = async () => {
        if (ischecked) {
            try {
                await axios.post(`${config.API_URL}/favmovie/delete`, {
                    member_id: window.sessionStorage.getItem("id"),
                    movie_title: title,
                });
            } catch (error) {
                console.error(error);
            }
            setIsChecked(false);
        } else {
            try {
                const { data } = await axios.post(`${config.API_URL}/favmovie/isDuplicateTitle`, {
                    member_id: window.sessionStorage.getItem("id"),
                    movie_title: title,
                });
                if (data !== 1) {
                    await axios.post(`${config.API_URL}/favmovie/insert`, {
                        member_id: window.sessionStorage.getItem("id"),
                        movie_title: title,
                        movie_summary: summary,
                        movie_image: medium_cover_image,
                    });
                }
            } catch (error) {
                console.error(error);
            }
            setIsChecked(true);
        }
    };

    return (
        <div>
            <Container fixed maxWidth={false} disableGutters md={{ height: "500%" }} style={containerStyle}>
                <Box style={btnStyle}>
                    <Grid
                        item
                        xs={6}
                        sm={3}
                        md={4}
                        style={{
                            marginTop: "0px",
                            justifyContent: "left",
                            color: "white",
                            fontSize: "1.7em",
                            fontWeight: "bold",
                            width: "300px",
                        }}
                    >
                        {title}
                    </Grid>
                    <Grid
                        container
                        style={{
                            marginTop: "12px",
                            flexDirection: "row",
                            width: "215px",
                            justifyContent: "space-between",
                        }}
                    >
                        <Grid onClick={() => handlelike()}>
                            {memberId !== null ? (
                                <Button
                                    variant="outlined"
                                    style={{ color: "white", backgroundColor: "#787777" }}
                                    startIcon={ischecked ? <StarIcon /> : <StarBorderIcon />}
                                >
                                    Like
                                </Button>
                            ) : (
                                <Button
                                    variant="outlined"
                                    style={{ color: "white", backgroundColor: "#787777", width: "90px" }}
                                    startIcon={<StarIcon />}
                                    disabled
                                >
                                    {likes}
                                </Button>
                            )}
                        </Grid>
                        <Grid>
                            <Button
                                variant="outlined"
                                startIcon={<InfoOutlinedIcon />}
                                onClick={handleOpen}
                                style={{ color: "white", backgroundColor: "#787777" }}
                            >
                                Details
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box style={imgStyle} />
                <Box style={playerStyle}>
                    {trailerKey ? (
                        <YouTube
                            videoId={trailerKey}
                            opts={{
                                width: "580",
                                height: "345",
                                playerVars: {
                                    autoplay: 0,
                                    rel: 0,
                                    modestbranding: 1,
                                },
                            }}
                            onEnd={(e) => {
                                e.target.stopVideo(0);
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: "580px",
                                height: "345px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#111",
                                color: "#aaa",
                            }}
                        >
                            No trailer available
                        </Box>
                    )}
                </Box>
            </Container>
            <Modal keepMounted open={open} onClose={handleClose}>
                <Box sx={style}>
                    <div style={{ display: "flex" }}>
                        <img
                            width="300px"
                            height="400px"
                            style={{
                                display: "flex",
                            }}
                            src={medium_cover_image}
                            alt="movie"
                        ></img>
                        <Typography
                            component="span"
                            sx={{
                                color: "white",
                            }}
                            style={{
                                marginLeft: "16px",
                                display: "flex",
                                width: "450px",
                                alignItems: "flex-start",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                style={{
                                    display: "block",
                                    flexDirection: "column",
                                }}
                            >
                                <h2 style={{ display: "block" }}>{title}</h2>
                                <p className="summary-scroll">{summary}</p>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
export default Banner_data;
